// =============================================================================
// features/sales/agenda/viewState.ts — Resolução pura do estado de conteúdo
// da lista da agenda (doc 26 §6.1 "Estados obrigatórios").
//
// Os 6 estados do DoD do slot:
//   1. no-permission     — gate de RBAC (fora deste resolver — ver AgendaPage)
//   2. flag-disabled     — gate de feature flag (fora deste resolver — ver AgendaPage)
//   3. loading           — fetch em curso, sem dado anterior em cache
//   4. error             — fetch falhou (recuperável — botão "Tentar novamente")
//   5. empty-no-agenda   — sucesso, zero itens, NENHUM filtro extra ativo
//   6. empty-filtered    — sucesso, zero itens, com filtro extra ativo (canal/
//      responsável/campanha/situação) — mensagem diferente ("limpar filtros"
//      em vez de "sem agenda")
//
// `success` é o 7º valor de retorno (lista com itens) — não é um "estado
// vazio" mas precisa existir para o componente saber quando renderizar a
// lista de verdade.
//
// Função pura — ver __tests__/viewState.test.ts.
// =============================================================================

export type AgendaContentState =
  | 'loading'
  | 'error'
  | 'empty-no-agenda'
  | 'empty-filtered'
  | 'success';

export interface ResolveAgendaContentStateInput {
  isLoading: boolean;
  isError: boolean;
  itemCount: number | undefined;
  /** true quando algum filtro além da aba ativa está aplicado (canal, responsável, campanha, situação). */
  hasExtraFilters: boolean;
}

export function resolveAgendaContentState({
  isLoading,
  isError,
  itemCount,
  hasExtraFilters,
}: ResolveAgendaContentStateInput): AgendaContentState {
  if (isLoading && itemCount === undefined) return 'loading';
  if (isError) return 'error';
  if (itemCount === 0) return hasExtraFilters ? 'empty-filtered' : 'empty-no-agenda';
  return 'success';
}
